import { render, staticRenderFns } from "./TermsPop.vue?vue&type=template&id=2c492bcf&scoped=true&"
import script from "./TermsPop.vue?vue&type=script&lang=js&"
export * from "./TermsPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c492bcf",
  null
  
)

component.options.__file = "TermsPop.vue"
export default component.exports